import { createApi } from '@/api/modules/utils'

const baseUrl = '/article_generation/content'
const api = createApi(baseUrl)

// 用户相关API
export const articleContentApi = {
  insert: api('insert', 'post'),
  copy: api('copy', 'post'),
  config: api('config', 'get'),
  list: api('list', 'get'),
  detail: api('detail', 'get'),
  update: api('update', 'post'),
  rename: api('rename', 'post'),
  delete: api('delete', 'get'),
  batchDelete: api('batch_delete', 'get'),
  select: api('select', 'get'),
  testSitemap: api('test_sitemap', 'post'),
}